import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Login from './Login'

import { actionCreators } from '@/checkout-instore-legacy/vendor/actions'

const mapStateToProps = (state) => ({
  loading: state.vendor.loading,
  store: state.vendor.store,
  vendor: state.vendor.vendor,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Login)
